var exports = {
  "D": "xa15a2ab7--92d40f--title",
};

module.exports = exports;
